var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { registerDecorator, ValidatorConstraint, } from 'class-validator';
let IsSnilsConstraint = class IsSnilsConstraint {
    /* eslint-disable no-magic-numbers */
    validate(value) {
        if (typeof value !== 'string' ||
            !(/[0-9]{11}/.test(value) ||
                /[0-9]{3}-[0-9]{3}-[0-9]{3} [0-9]{2}/.test(value))) {
            return false;
        }
        const snils = value.replace(/(-| )/g, '');
        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(snils[i], 10) * (9 - i);
        }
        let checkDigit = 0;
        if (sum < 100) {
            checkDigit = sum;
        }
        else if (sum > 101) {
            checkDigit = sum % 101;
            /* istanbul ignore next */
            if (checkDigit === 100) {
                checkDigit = 0;
            }
        }
        return checkDigit === parseInt(snils.slice(-2), 10);
    }
    /* eslint-enable no-magic-numbers */
    defaultMessage(args) {
        return `${args.property} is not snils`;
    }
};
IsSnilsConstraint = __decorate([
    ValidatorConstraint({ name: 'IsSnils' })
], IsSnilsConstraint);
export { IsSnilsConstraint };
export function IsSnils(validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [],
            validator: IsSnilsConstraint,
        });
    };
}
